import {
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { LoggerService } from './logger.service';
import { ToastService } from './toast.service';
import { ValidationIssuesResponse } from '../shared/models/validation-issues/order-response.model';
import { InspectionKind } from './inspection-kind.enum';

@Injectable({
  providedIn: 'root',
})
export class ValidationIssuesService {
  private readonly _apiUrlOrder = `${
    import.meta.env.NG_APP_API_URL
  }/backoffice/v1/orderValidationIssues/`;


  constructor(
    private http: HttpClient,
    private loggerService: LoggerService,
    private toastService: ToastService
  ) {}


  getValidationIssuesFileName(id: string): Observable<ValidationIssuesResponse> {
    return this.http
      .get<ValidationIssuesResponse>(`${this._apiUrlOrder}${id}/severity/${InspectionKind.HYGIENE_INSPECTION}`)
      .pipe(catchError(this.handleError.bind(this)));
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'Ein unbekannter Fehler ist aufgetreten!';

    if (error.error instanceof ErrorEvent) {
      // Client-seitiger oder Netzwerkfehler
      errorMessage = `Ein Fehler ist aufgetreten: ${error.error.message}`;
    } else {
      // Backend-seitiger Fehler
      errorMessage =
        `Backend hat mit Status ${error.status} geantwortet. ` +
        `Grund dafür ist: ${error.message}`;
    }

    this.loggerService.error(errorMessage);
    this.toastService.show('warn', 'Ein Fehler ist aufgetreten', errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
